// ════════════════════════════════════════════════════════════════════
//  holidaySchedule.js
//  Розклад свят → авто-зміна теми
//  Теми активні за N днів ДО і в день свята
// ════════════════════════════════════════════════════════════════════

// Функція для обчислення Великодня (Western Easter)
function getEasterDate(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}

// Функція для Good Friday (2 дні до Великодня)
function getGoodFriday(year) {
  const easter = getEasterDate(year);
  const gf = new Date(easter);
  gf.setDate(gf.getDate() - 2);
  return gf;
}

// Canadian Thanksgiving — 2nd Monday of October
function getThanksgiving(year) {
  const d = new Date(year, 9, 1); // Oct 1
  const day = d.getDay();
  const monday = day === 1 ? 8 : day === 0 ? 9 : 9 + (8 - day);
  return new Date(year, 9, monday);
}

// Victoria Day — last Monday before May 25
function getVictoriaDay(year) {
  const d = new Date(year, 4, 25); // May 25
  const day = d.getDay();
  const diff = day === 1 ? 7 : day === 0 ? 6 : day - 1;
  return new Date(year, 4, 25 - diff);
}

// Family Day Ontario — 3rd Monday of February
function getFamilyDay(year) {
  const d = new Date(year, 1, 1); // Feb 1
  const day = d.getDay();
  const firstMonday = day === 1 ? 1 : day === 0 ? 2 : 9 - day;
  return new Date(year, 1, firstMonday + 14);
}

// Labour Day — 1st Monday of September
function getLabourDay(year) {
  const d = new Date(year, 8, 1); // Sep 1
  const day = d.getDay();
  const firstMonday = day === 1 ? 1 : day === 0 ? 2 : 9 - day;
  return new Date(year, 8, firstMonday);
}

// Mother's Day — 2nd Sunday of May
function getMothersDay(year) {
  const d = new Date(year, 4, 1); // May 1
  const day = d.getDay();
  const firstSunday = day === 0 ? 1 : 8 - day;
  return new Date(year, 4, firstSunday + 7);
}

// Father's Day — 3rd Sunday of June
function getFathersDay(year) {
  const d = new Date(year, 5, 1); // Jun 1
  const day = d.getDay();
  const firstSunday = day === 0 ? 1 : 8 - day;
  return new Date(year, 5, firstSunday + 14);
}

// Hanukkah 2025-2030 approximate (varies by Jewish calendar)
const HANUKKAH_DATES = {
  2024: new Date(2024, 11, 25),
  2025: new Date(2025, 11, 14),
  2026: new Date(2026, 11, 4),
  2027: new Date(2027, 11, 24),
  2028: new Date(2028, 11, 12),
  2029: new Date(2029, 11, 1),
  2030: new Date(2030, 11, 20),
};

// Chinese New Year dates
const CHINESE_NY_DATES = {
  2024: new Date(2024, 1, 10),
  2025: new Date(2025, 0, 29),
  2026: new Date(2026, 1, 17),
  2027: new Date(2027, 1, 6),
  2028: new Date(2028, 0, 26),
};

// ── Build holiday schedule ───────────────────────────────────────────
// { theme, start, end } — тема активна від start до end включно
export function getHolidaySchedule(year) {
  const easter     = getEasterDate(year);
  const goodFriday = getGoodFriday(year);
  const thanksgiving = getThanksgiving(year);
  const victoriaDay  = getVictoriaDay(year);
  const familyDay    = getFamilyDay(year);
  const labourDay    = getLabourDay(year);
  const mothersDay   = getMothersDay(year);
  const fathersDay   = getFathersDay(year);
  const hanukkah     = HANUKKAH_DATES[year] || new Date(year, 11, 18);
  const chineseNY    = CHINESE_NY_DATES[year] || new Date(year, 1, 10);

  const d = (month, day) => new Date(year, month - 1, day);
  const range = (date, before, after = 0) => {
    const start = new Date(date); start.setDate(start.getDate() - before);
    const end   = new Date(date); end.setDate(end.getDate() + after);
    return { start, end };
  };

  return [
    // ── Січень ──
    { theme: 'newyear',      ...range(d(1, 1),   3, 2) },   // Jan 1 ±

    // ── Лютий ──
    { theme: 'familyday',    ...range(familyDay, 5, -4) },  // Feb 11-12 only
    { theme: 'valentine',    ...range(d(2, 14),  1, 1) },   // Feb 13-15

    // ── Березень ──
    { theme: 'patrick',      ...range(d(3, 17),  5, 0) },   // Mar 17

    // ── Квітень ──
    { theme: 'goodfriday',   ...range(goodFriday, 2, 0) },  // Good Friday
    { theme: 'easter',       ...range(easter,    0, 1) },   // Easter Sunday+Mon

    // ── Травень ──
    { theme: 'victoria',    ...range(victoriaDay, 3, 0) }, // Victoria Day
    { theme: 'mothersday',   ...range(mothersDay,  3, 0) }, // 2nd Sun May

    // ── Червень ──
    { theme: 'fathersday',   ...range(fathersDay,  3, 0) }, // 3rd Sun June

    // ── Липень ──
    { theme: 'canada',       ...range(d(7, 1),   3, 1) },   // Jul 1

    // ── Вересень ──
    { theme: 'birthday',     ...range(d(9, 5),   0, 0) },   // Sep 5 only 🎂
    { theme: 'labour',       ...range(labourDay,  2, 0) },   // 1st Mon Sep
    { theme: 'truth',        ...range(d(9, 30),  2, 0) },   // Sep 30

    // ── Жовтень ──
    { theme: 'thanksgiving', ...range(thanksgiving, 4, 1) },// 2nd Mon Oct
    { theme: 'halloween',    ...range(d(10, 31), 5, 0) },   // Oct 31

    // ── Листопад ──
    { theme: 'remembrance',  ...range(d(11, 11), 2, 0) },   // Nov 11

    // ── Грудень ──
    { theme: 'hanukkah',     ...range(hanukkah,  1, 8) },   // 8 days
    { theme: 'christmas',    ...range(d(12, 25), 7, 1) },   // Dec 25
    { theme: 'newyear',      ...range(d(12, 31), 2, 0) },   // Dec 31

    // ── Плаваючі ──
    { theme: 'chineseny',    ...range(chineseNY, 3, 5) },   // Chinese NY
    { theme: 'vyshyvanka',   ...range(d(5, 19),  2, 0) },   // ~3rd Thu May
    { theme: 'ukraine',      ...range(d(8, 24),  3, 1) },   // Aug 24
  ];
}

// ── Get active holiday theme for today ──────────────────────────────
export function getHolidayTheme() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const year = today.getFullYear();

  const schedule = getHolidaySchedule(year);

  for (const { theme, start, end } of schedule) {
    const s = new Date(start); s.setHours(0,0,0,0);
    const e = new Date(end);   e.setHours(23,59,59,999);
    if (today >= s && today <= e) return theme;
  }
  return null; // немає активного свята
}

// ── Get upcoming holiday ─────────────────────────────────────────────
export function getUpcomingHoliday(daysAhead = 30) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const year = today.getFullYear();
  const schedule = [
    ...getHolidaySchedule(year),
    ...getHolidaySchedule(year + 1),
  ];

  let nearest = null;
  for (const item of schedule) {
    const s = new Date(item.start);
    s.setHours(0,0,0,0);
    const diffDays = Math.round((s - today) / 86400000);
    if (diffDays > 0 && diffDays <= daysAhead) {
      if (!nearest || diffDays < Math.round((new Date(nearest.start) - today) / 86400000)) {
        nearest = { ...item, daysUntil: diffDays };
      }
    }
  }
  return nearest;
}
